export default "__VITE_ASSET__C58UKGYM__"